import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import "./dtl2020.css";

import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo"; 
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function DTL2020() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "dtl20";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      gameName={"20-20 D T L"}
    
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container dtl20"> */}
      {/* <div className="casino-header">
          <span className="casino-name">
            20-20 D T L
            <a className="ms-1">
              <small>Rules</small>
            </a>
          </span>
          <span className="casino-rid d-none d-xl-inline-block">
            <small>
              Round ID: <span>119250425155332</span>
            </small>
          </span>
        </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none">
          <ul className="nav nav-tabs menu-tabs">
            <li className="nav-item">
              <div className="nav-link active">Game</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Placed Bet (0)</div>
            </li>
          </ul>
          <div className="pe-2">
            <span className="casino-rid">
              Round ID: <span>119250425155332</span>
            </span>
          </div>
        </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video">
            <div className="video-box-container">
              <div className="casino-video-box">
                <iframe src="/mediaplayer/dtl20/35c1f17a-d146-4059-932a-dd569e6920a0?ip=122.160.119.41" />
              </div>
            </div>
            <div className="casino-video-cards">
              <div className="d-flex flex-wrap justify-content-between">
                <div>
                  <div className="flip-card-container">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">8</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">8</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">7</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">7</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}

      <div className="casino-detail dtl20">
        <div className="casino-table">
          <div className="casino-table-box d-none d-md-flex">
            <div className="casino-table-left-box">
              <div className="casino-table-header">
                <div className="casino-nation-detail" />
                <div className="casino-odds-box back">Dragon</div>
                <div className="casino-odds-box back">Tiger</div>
                <div className="casino-odds-box back">Lion</div>
              </div>
              <div className="casino-table-body">
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">Winner</div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  {/* <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Winner D", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Winner D", casinoData, true)}
                    </span>
                  </div> */}
                  {/* <div className="casino-nation-book">
                    {getCasinoPlExposureByRunner(casinoPlData, "Winner D")}
                  </div> */}
                  <div
                    className={`casino-odds-box back ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Winner D", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Winner D", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Winner D")}
                    </div>
                  </div>

                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Winner T", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {" "}
                      {getOddForEntity("Winner T", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Winner T")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Winner L", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Winner L", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Winner L")}
                    </div>
                  </div>
                </div>
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      Black
                      <span className="card-icon ms-1">
                        <span className="card-black ">{"}"}</span>
                      </span>
                      <span className="card-icon ms-1">
                        <span className="card-black ">]</span>
                      </span>
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Black D", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Black D", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Black D")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Black T", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Black T", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Black T")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Black L", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Black L", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Black L")}
                    </div>
                  </div>
                </div>
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      Red
                      <span className="card-icon ms-1">
                        <span className="card-red ">{"{"}</span>
                      </span>
                      <span className="card-icon ms-1">
                        <span className="card-red ">[</span>
                      </span>
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Red D", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Red D", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Red D")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Red T", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Red T", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Red T")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Red L", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Red L", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Red L")}
                    </div>
                  </div>
                </div>
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">Odd</div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Odd D", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Odd D", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Odd D")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Odd T", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Odd T", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Odd T")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Odd L", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Odd L", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Odd L")}
                    </div>
                  </div>
                </div>
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">Even</div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Even D", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Even D", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Even D")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Even T", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Even T", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Even T")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Even L", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Even L", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Even L")}
                    </div>
                  </div>
                </div>
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/A.png" />
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Dragon A", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Dragon A", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Dragon A")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Tiger A", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Tiger A", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Tiger A")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Lion A", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Lion A", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Lion A")}
                    </div>
                  </div>
                </div>
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/2.png" />
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Dragon 2", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Dragon 2", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Dragon 2")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Tiger 2", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Tiger 2", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Tiger 2")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Lion 2", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Lion 2", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Lion 2")}
                    </div>
                  </div>
                </div>
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/3.png" />
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Dragon 3", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Dragon 3", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Dragon 3")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Tiger 3", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Tiger 3", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Tiger 3")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Lion 3", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Lion 3", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Lion 3")}
                    </div>
                  </div>
                </div>
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/4.png" />
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Dragon 4", casinoData, dispatch, "back")
                    }
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Dragon 4", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Dragon 4")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Tiger 4", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Tiger 4", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Tiger 4")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Lion 4", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Lion 4", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Lion 4")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="casino-table-right-box">
              <div className="casino-table-header">
                <div className="casino-nation-detail" />
                <div className="casino-odds-box back">Dragon</div>
                <div className="casino-odds-box back">Tiger</div>
                <div className="casino-odds-box back">Lion</div>
              </div>
              <div className="casino-table-body">
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/5.png" />
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Dragon 5", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Dragon 5", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Dragon 5")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Tiger 5", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Tiger 5", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Tiger 5")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Lion 5", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Lion 5", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Lion 5")}
                    </div>
                  </div>
                </div>
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/6.png" />
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Dragon 6", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Dragon 6", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Dragon 6")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Tiger 6", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Tiger 6", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Tiger 6")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Lion 6", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Lion 6", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Lion 6")}
                    </div>
                  </div>
                </div>
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/7.png" />
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Dragon 7", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Dragon 7", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Dragon 7")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Tiger 7", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Tiger 7", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Tiger 7")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Lion 7", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Lion 7", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Lion 7")}
                    </div>
                  </div>
                </div>
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/8.png" />
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Dragon 8", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Dragon 8", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Dragon 8")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Tiger 8", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Tiger 8", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Tiger 8")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Lion 8", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Lion 8", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Lion 8")}
                    </div>
                  </div>
                </div>
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/9.png" />
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Dragon 9", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Dragon 9", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Dragon 9")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Tiger 9", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Tiger 9", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Tiger 9")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Lion 9", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Lion 9", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Lion 9")}
                    </div>
                  </div>
                </div>
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/10.png" />
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Dragon 10", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Dragon 10", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Dragon 10")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Tiger 10", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Tiger 10", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Tiger 10")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Lion 10", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Lion 10", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Lion 10")}
                    </div>
                  </div>
                </div>
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/J.png" />
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Dragon J", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Dragon J", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Dragon J")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Tiger J", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Tiger J", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Tiger J")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Lion J", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Lion J", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Lion J")}
                    </div>
                  </div>
                </div>
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/Q.png" />
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Dragon Q", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Dragon Q", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Dragon Q")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Tiger Q", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Tiger Q", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Tiger Q")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Lion Q", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Lion Q", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Lion Q")}
                    </div>
                  </div>
                </div>
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/K.png" />
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Dragon K", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Dragon K", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Dragon K")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Tiger K", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Tiger K", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Tiger K")}
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Lion K", casinoData, dispatch, "back")
                    }
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    {/* <span className="casino-odds"> */}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {getOddForEntity("Lion K", casinoData, true)}
                    </span>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Lion K")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <ul className="d-xl-none nav nav-pills" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                type="button"
                id="uncontrolled-tab-example-tab-0"
                role="tab"
                data-rr-ui-event-key={0}
                aria-controls="uncontrolled-tab-example-tabpane-0"
                aria-selected="true"
                className="nav-link active"
              >
                Dragon
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                type="button"
                id="uncontrolled-tab-example-tab-1"
                role="tab"
                data-rr-ui-event-key={1}
                aria-controls="uncontrolled-tab-example-tabpane-1"
                aria-selected="false"
                tabIndex={-1}
                className="nav-link"
              >
                Tiger
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                type="button"
                id="uncontrolled-tab-example-tab-2"
                role="tab"
                data-rr-ui-event-key={2}
                aria-controls="uncontrolled-tab-example-tabpane-2"
                aria-selected="false"
                tabIndex={-1}
                className="nav-link"
              >
                Lion
              </button>
            </li>
          </ul> */}
           <ul className="d-xl-none nav nav-pills" role="tablist">
        {['Dragon', 'Tiger', 'Lion'].map((tabLabel, index) => (
          <li className="nav-item" role="presentation" key={index}>
            <button
              type="button"
              id={`uncontrolled-tab-example-tab-${index}`}
              role="tab"
              data-rr-ui-event-key={index}
              aria-controls={`uncontrolled-tab-example-tabpane-${index}`}
              aria-selected={activeTab === index}
              tabIndex={activeTab === index ? 0 : -1}
              className={`nav-link ${activeTab === index ? 'active' : ''}`}
              onClick={() => setActiveTab(index)}
            >
              {tabLabel}
            </button>
          </li>
        ))}
      </ul>
          <div className="tab-content">
            <div
              role="tabpanel"
              id="uncontrolled-tab-example-tabpane-0"
              aria-labelledby="uncontrolled-tab-example-tab-0"
              className="fade d-xl-none tab-pane active show"
            >
              <div className="casino-table-box">
                {/* <div className="casino-table-left-box">
                  <div className="casino-table-body">
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">Winner</div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">2.94</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          Black
                          <span className="card-icon ms-1">
                            <span className="card-black ">{"}"}</span>
                          </span>
                          <span className="card-icon ms-1">
                            <span className="card-black ">]</span>
                          </span>
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">1.97</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          Red
                          <span className="card-icon ms-1">
                            <span className="card-red ">{"{"}</span>
                          </span>
                          <span className="card-icon ms-1">
                            <span className="card-red ">[</span>
                          </span>
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">1.97</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">Odd</div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">1.83</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">Even</div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">2.12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/A.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/2.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/3.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/4.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="casino-table-right-box">
                  <div className="casino-table-body">
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/5.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/6.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/7.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/8.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/9.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/10.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/J.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/Q.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/K.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="casino-table-left-box">
                  <div className="casino-table-header">
                    <div className="casino-nation-detail" />
                    <div className="casino-odds-box back">Dragon</div>
                    <div className="casino-odds-box back">Tiger</div>
                    <div className="casino-odds-box back">Lion</div>
                  </div>
                  <div className="casino-table-body">
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">Winner</div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      {/* <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Winner D", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Winner D", casinoData, true)}
                    </span>
                  </div> */}
                      {/* <div className="casino-nation-book">
                    {getCasinoPlExposureByRunner(casinoPlData, "Winner D")}
                  </div> */}
                      <div
                        className={`casino-odds-box back ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Winner D", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Winner D", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Winner D"
                          )}
                        </div>
                      </div>

                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Winner T", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {" "}
                          {getOddForEntity("Winner T", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Winner T"
                          )}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Winner L", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Winner L", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Winner L"
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          Black
                          <span className="card-icon ms-1">
                            <span className="card-black ">{"}"}</span>
                          </span>
                          <span className="card-icon ms-1">
                            <span className="card-black ">]</span>
                          </span>
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Black D", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Black D", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Black D")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Black T", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Black T", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Black T")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Black L", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Black L", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Black L")}
                        </div>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          Red
                          <span className="card-icon ms-1">
                            <span className="card-red ">{"{"}</span>
                          </span>
                          <span className="card-icon ms-1">
                            <span className="card-red ">[</span>
                          </span>
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Red D", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Red D", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Red D")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Red T", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Red T", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Red T")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Red L", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Red L", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Red L")}
                        </div>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">Odd</div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Odd D", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Odd D", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Odd D")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Odd T", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Odd T", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Odd T")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Odd L", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Odd L", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Odd L")}
                        </div>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">Even</div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Even D", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Even D", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Even D")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Even T", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Even T", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Even T")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Even L", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Even L", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Even L")}
                        </div>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/A.png" />
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Dragon A", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Dragon A", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Dragon A"
                          )}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Tiger A", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Tiger A", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Tiger A")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Lion A", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Lion A", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Lion A")}
                        </div>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/2.png" />
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Dragon 2", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Dragon 2", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Dragon 2"
                          )}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Tiger 2", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Tiger 2", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Tiger 2")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Lion 2", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Lion 2", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Lion 2")}
                        </div>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/3.png" />
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Dragon 3", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Dragon 3", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Dragon 3"
                          )}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Tiger 3", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Tiger 3", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Tiger 3")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Lion 3", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Lion 3", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Lion 3")}
                        </div>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/4.png" />
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Dragon 4", casinoData, dispatch, "back")
                        }
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Dragon 4", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Dragon 4"
                          )}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Tiger 4", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Tiger 4", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Tiger 4")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Lion 4", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Lion 4", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Lion 4")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="casino-table-right-box">
                  {/* <div className="casino-table-header">
                    <div className="casino-nation-detail" />
                    <div className="casino-odds-box back">Dragon</div>
                    <div className="casino-odds-box back">Tiger</div>
                    <div className="casino-odds-box back">Lion</div>
                  </div> */}
                  <div className="casino-table-body">
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/5.png" />
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Dragon 5", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Dragon 5", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Dragon 5"
                          )}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Tiger 5", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Tiger 5", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Tiger 5")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Lion 5", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Lion 5", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Lion 5")}
                        </div>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/6.png" />
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Dragon 6", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Dragon 6", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Dragon 6"
                          )}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Tiger 6", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Tiger 6", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Tiger 6")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Lion 6", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Lion 6", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Lion 6")}
                        </div>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/7.png" />
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Dragon 7", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Dragon 7", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Dragon 7"
                          )}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Tiger 7", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Tiger 7", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Tiger 7")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Lion 7", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Lion 7", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Lion 7")}
                        </div>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/8.png" />
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Dragon 8", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Dragon 8", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Dragon 8"
                          )}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Tiger 8", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Tiger 8", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Tiger 8")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Lion 8", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Lion 8", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Lion 8")}
                        </div>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/9.png" />
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Dragon 9", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Dragon 9", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Dragon 9"
                          )}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Tiger 9", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Tiger 9", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Tiger 9")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Lion 9", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Lion 9", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Lion 9")}
                        </div>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/10.png" />
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Dragon 10", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Dragon 10", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Dragon 10"
                          )}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Tiger 10", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Tiger 10", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Tiger 10"
                          )}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Lion 10", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Lion 10", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Lion 10")}
                        </div>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/J.png" />
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Dragon J", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Dragon J", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Dragon J"
                          )}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Tiger J", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Tiger J", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Tiger J")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Lion J", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Lion J", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Lion J")}
                        </div>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/Q.png" />
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Dragon Q", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Dragon Q", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Dragon Q"
                          )}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Tiger Q", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Tiger Q", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Tiger Q")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Lion Q", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Lion Q", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Lion Q")}
                        </div>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/K.png" />
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Dragon K", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Dragon K", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(
                            casinoPlData,
                            "Dragon K"
                          )}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Tiger K", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Tiger K", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Tiger K")}
                        </div>
                      </div>
                      {/* <div className="casino-odds-box back"> */}
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Lion K", casinoData, dispatch, "back")
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "5px",
                        }}
                      >
                        {/* <span className="casino-odds"> */}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {getOddForEntity("Lion K", casinoData, true)}
                        </span>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "2px",
                          }}
                        >
                          {getCasinoPlExposureByRunner(casinoPlData, "Lion K")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div
              role="tabpanel"
              id="uncontrolled-tab-example-tabpane-1"
              aria-labelledby="uncontrolled-tab-example-tab-1"
              className="fade d-xl-none tab-pane"
            >
              <div className="casino-table-box">
                <div className="casino-table-left-box">
                  <div className="casino-table-body">
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">Winner</div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">2.94</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          Black
                          <span className="card-icon ms-1">
                            <span className="card-black ">{"}"}</span>
                          </span>
                          <span className="card-icon ms-1">
                            <span className="card-black ">]</span>
                          </span>
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">1.97</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          Red
                          <span className="card-icon ms-1">
                            <span className="card-red ">{"{"}</span>
                          </span>
                          <span className="card-icon ms-1">
                            <span className="card-red ">[</span>
                          </span>
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">1.97</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">Odd</div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">1.83</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">Even</div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">2.12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/A.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/2.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/3.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/4.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="casino-table-right-box">
                  <div className="casino-table-body">
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/5.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/6.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/7.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/8.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/9.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/10.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/J.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/Q.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/K.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              role="tabpanel"
              id="uncontrolled-tab-example-tabpane-2"
              aria-labelledby="uncontrolled-tab-example-tab-2"
              className="fade d-xl-none tab-pane"
            >
              <div className="casino-table-box">
                <div className="casino-table-left-box">
                  <div className="casino-table-body">
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">Winner</div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">2.94</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          Black
                          <span className="card-icon ms-1">
                            <span className="card-black ">{"}"}</span>
                          </span>
                          <span className="card-icon ms-1">
                            <span className="card-black ">]</span>
                          </span>
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">1.97</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          Red
                          <span className="card-icon ms-1">
                            <span className="card-red ">{"{"}</span>
                          </span>
                          <span className="card-icon ms-1">
                            <span className="card-red ">[</span>
                          </span>
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">1.97</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">Odd</div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">1.83</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">Even</div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">2.12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/A.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/2.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/3.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/4.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="casino-table-right-box">
                  <div className="casino-table-body">
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/5.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/6.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/7.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/8.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/9.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/10.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/J.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/Q.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-nation-detail">
                        <div className="casino-nation-name">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/K.png" />
                        </div>
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">12</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        {/* <div className="casino-last-result-title">
              <span>Last Result</span>
              <span>
                <a href="/casino-results/dtl20">View All</a>
              </span>
            </div>
            <div className="casino-last-results">
              <span className="result result-b">T</span>
              <span className="result result-a">D</span>
              <span className="result result-c">L</span>
              <span className="result result-c">L</span>
              <span className="result result-a">D</span>
              <span className="result result-c">L</span>
              <span className="result result-c">L</span>
              <span className="result result-c">L</span>
              <span className="result result-a">D</span>
              <span className="result result-c">L</span>
            </div> */}
      </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="sidebar right-sidebar casino-right-sidebar">
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div> */}
      {/* </div> */}
    </CasinoPage>
  );
}
